import { useState } from 'react';
import { accessLogin, type AccessLoginDto } from '../api';

export function LoginScreen({ onLogin, notice = '' }: { onLogin: (result: AccessLoginDto) => void; notice?: string }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!/^\d{6}$/.test(code)) { setError('请输入六位数字口令'); return; }
    setBusy(true); setError('');
    try { onLogin(await accessLogin(code)); }
    catch (caught) { setError(caught instanceof Error ? caught.message : '口令错误'); }
    finally { setBusy(false); }
  };
  return <main className="login-shell"><section className="login-card"><div className="brand-mark">◉</div><h1>核心联赛数据台</h1><p>输入管理员分配的口令进入系统</p><input value={code} onChange={(event) => setCode(event.target.value.replace(/\D/g, '').slice(0, 6))} onKeyDown={(event) => { if (event.key === 'Enter') void submit(); }} placeholder="六位数字口令" type="password" aria-label="六位数字口令" autoComplete="one-time-code" inputMode="numeric" maxLength={6} autoFocus />{(error || notice) && <div className="login-error">{error || notice}</div>}<button disabled={busy} onClick={() => void submit()}>{busy ? '验证中…' : '进入系统'}</button><small>仅限授权用户，公开注册已关闭</small></section></main>;
}